module.exports = __webpack_public_path__ + "static/media/dashboard.3f6f2ef8.svg";